const SLUG_TO_SUFFIX = {
  'what-makes-a-great-peer-review': 'what-makes-a-great-peer-review-2',
  'standard-tutoring-rubric': 'standard-tutoring-rubric-3',
  'self-reflection-exercise': 'self-reflection-exercise-8',
  'training-recap': 'training-recap-6',
  faq: 'faq-4',
  'peer-reviewer-growth-path': 'peer-reviewer-growth-path-9',
} as const

export function getPeerReviewGuideUrl(page?: keyof typeof SLUG_TO_SUFFIX): string {
  return `https://coda.io/@shwcommunity/peer-review-guide${page != null ? `/${SLUG_TO_SUFFIX[page]}` : ''}`
}
